import { useEffect } from "react";

import { ApiError } from "@/api";
import { reportError } from "@/lib/report";

/**
 * The words of a failure: the API's message, the shell's (a Tauri command
 * fails with a plain string, decision 130: ThomasS's livery offer said
 * "Something went wrong" over the companion's real reason), or the generic
 * line.
 */
export function errorMessage(error: unknown): string {
  if (error instanceof ApiError) return error.status === 401 ? "Sign in to continue." : error.message;
  if (error instanceof Error) return error.message;
  if (typeof error === "string" && error.trim()) return error;
  return "Something went wrong.";
}

/** One line for a failed request: the API's message, the shell's, or the generic one. */
export function ErrorNote({ error, className = "" }: { error: unknown; className?: string }) {
  const message = error ? errorMessage(error) : null;
  const code = error instanceof ApiError ? error.code : undefined;
  // What the pilot was shown reaches the platform (decision 140): a sign-in needed is no error.
  useEffect(() => {
    if (!error || message === null) return;
    if (error instanceof ApiError && error.status === 401) return;
    reportError({ code: code ?? (error instanceof Error ? error.name : "shown"), message });
  }, [error, message, code]);
  if (!error || message === null) return null;
  return (
    <div className={`alert ${className}`} role="alert" data-testid="error" data-code={code}>
      {message}
    </div>
  );
}
